'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formFieldStyles = undefined;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _helpInfo = require('@marmalade/help-info');
var _label = require('../label');
var _label2 = _interopRequireDefault(_label);
var _error = require('../error');
var _error2 = _interopRequireDefault(_error);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var formFieldStyles = exports.formFieldStyles = function formFieldStyles(_ref) {
  var theme = _ref.theme,
    disabled = _ref.disabled;
  return Object.assign({
    position: 'relative',
    paddingBottom: theme.space_md
  }, disabled ? {
    opacity: 0.5,
    pointerEvents: 'none'
  } : {});
};
var FormFieldWrapper = (0, _glamorous2.default)('div')(formFieldStyles);
FormField.propTypes = {
  children: _propTypes.node.isRequired,
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  name: _propTypes.string.isRequired,
  error: _propTypes.string,
  helpText: _propTypes.string,
  extra: _propTypes.node
};
FormField.defaultProps = {
  label: undefined,
  error: undefined,
  helpText: undefined,
  extra: undefined
};
function FormField(_ref2) {
  var children = _ref2.children,
    label = _ref2.label,
    error = _ref2.error,
    name = _ref2.name,
    helpText = _ref2.helpText,
    extra = _ref2.extra,
    rest = _objectWithoutProperties(_ref2, ['children', 'label', 'error', 'name', 'helpText', 'extra']);
  var invalid = error && error.length;
  return _react2.default.createElement(FormFieldWrapper, rest, label && _react2.default.createElement(_label2.default, {
    name: name,
    helpText: !!helpText
  }, label), helpText && _react2.default.createElement(_helpInfo.HelpText, {
    id: 'help-' + name,
    css: {
      '& > div': {
        paddingBottom: '.5rem'
      }
    }
  }, helpText), children, invalid && _react2.default.createElement(_error2.default, null, error), extra);
}
exports.default = FormField;